import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Page404 from '@src/mobile/components/Page404';

const Layout = () => {
    return <Page404 />;
};

export default errorBoundary(Layout);
